<template>
  <div class="ml-5 mr-5">
    <h1 style="text-align: center;" class="mt-3">Checkout</h1>

    <div style="max-width: 600px; margin: 0 auto;" v-if="!$store.state.isUserLoggedIn">
      <p style="padding: 0px; margin: 0px" class="link" @click="signInPage">Sign In</p>
      <v-radio-group v-model="radios" :mandatory="true" style="margin-top: 0px;">
        <v-radio label="Continue As Guest" value="guest" color="success"></v-radio>
        <v-radio label="Create Account" value="signup" color="success"></v-radio>
      </v-radio-group>
    </div>

    <div
      v-if="this.radios == 'guest' && !$store.state.isUserLoggedIn"
      v-bind:class="{ errorShake: isErrorShake }"
      class="mt-1 mb-6"
      style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
    >
      <h2 class="pt-0 mt-0 mb-4" style="text-align: center;">Shipping Information</h2>
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <v-form ref="formGuest">
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Email"
            v-model="email"
            type="email"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Name"
            v-model="name"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Address Line 1"
            v-model="address1"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Address Line 2"
            v-model="address2"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="City"
            v-model="city"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-select
            v-model="states"
            :items="statesOptions"
            label="State"
            class="ml-2 mr-2"
            color="green"
          ></v-select>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Zipcode"
            v-model="zipcode"
          ></v-text-field>
        </div>
        <div style="width: 60%; margin: 0 auto;">
          <v-btn
            class="mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            @click="guestContinue"
          >Continue!</v-btn>
        </div>
      </v-form>
    </div>

    <div
      v-if="this.radios == 'signup' && !$store.state.isUserLoggedIn"
      v-bind:class="{ errorShake: isErrorShake }"
      class="mt-6"
      style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
    >
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <v-form ref="formSignup">
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Email"
            v-model="email"
            type="email"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Password"
            v-model="password"
            type="password"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Confirm Password"
            v-model="password2"
            type="password"
          ></v-text-field>
        </div>
        <div style="width: 60%; margin: 0 auto;">
          <v-btn
            class="mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            @click="register"
          >Register!</v-btn>
        </div>
      </v-form>
    </div>
    <div
      v-if="$store.state.isUserLoggedIn"
      v-bind:class="{ errorShake: isErrorShake }"
      class="mt-1 mb-6 pt-2"
      style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
    >
      <h2 class="pt-0 mt-0 mb-4" style="text-align: center;">Shipping Information</h2>
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <div v-if="this.message != ''">
        <v-alert type="success" v-bind="this.message" style="font-weight: bold;">{{this.message}}</v-alert>
      </div>

      <v-form ref="form">
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-select
            v-model="selectedAddress"
            :items="addressBook"
            v-on:change="setAddress"
            label="Address Book"
            class="ml-2 mr-2"
            color="green"
          ></v-select>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Name"
            v-model="name"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Address Line 1"
            v-model="address1"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Address Line 2"
            v-model="address2"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="City"
            v-model="city"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-select
            v-model="states"
            :items="statesOptions"
            label="State"
            class="ml-2 mr-2"
            color="green"
          ></v-select>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Zipcode"
            v-model="zipcode"
          ></v-text-field>
        </div>
        <v-row
          style="height: 40px;"
          class="pb-0 mb-0"
          no-gutters
          v-if="this.selectedAddress == 'Add new address' && this.$store.state.isUserLoggedIn"
        >
          <v-col cols="2" sm="1">
            <v-checkbox
              v-model="this.saveAddress"
              v-on:change="setSaveBox"
              style="padding: 5px; margin: 0px;"
            ></v-checkbox>
          </v-col>
          <v-col cols="10" sm="11">
            <p class="pt-1 pb-0 mb-0">Save to address book</p>
          </v-col>
        </v-row>

        <v-row
          no-gutters
          v-if="this.saveAddress == true && this.selectedAddress == 'Add new address' && this.$store.state.isUserLoggedIn"
        >
          <v-col cols="2" sm="1">
            <v-checkbox
              v-model="this.defaultAddress"
              v-on:change="setDefaultBox"
              style="padding: 5px; margin: 0px;"
            ></v-checkbox>
          </v-col>
          <v-col cols="10" sm="11">
            <p class="pt-1">Save as default address</p>
          </v-col>
        </v-row>

        <div style="width: 60%; margin: 0 auto;">
          <v-btn
            class="mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            @click="userContinue"
          >Continue</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";
import UserService from "@/services/UserService";

export default {
  data: () => ({
    radios: "guest",
    name: "",
    address1: "",
    address2: "",
    city: "",
    states: "",
    statesOptions: [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District Of Columbia",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming"
    ],
    selectedAddress: "",
    addressBook: ["Add new address"],
    zipcode: "",
    email: "",
    password: "",
    password2: "",
    error: "",
    message: "",
    saveAddress: true,
    defaultAddress: true,
    isErrorShake: false
  }),
  mounted() {
    this.scrollToTop();
    if (this.$store.state.user.addressBook.length > 0) {
      let noDefault = true;
      this.$store.state.user.addressBook.forEach(address => {
        if (address.default) {
          noDefault = false;
          this.selectedAddress = address.address1;
          this.name = address.name;
          this.address1 = address.address1;
          this.address2 = address.address2;
          this.city = address.city;
          this.states = address.state;
          this.zipcode = address.zipcode;
        }
        this.addressBook.push(address.address1);
        if (noDefault) {
          this.selectedAddress = "Add new address";
        }
      });
    } else {
      this.selectedAddress = "Add new address";
    }
  },
  methods: {
    signInPage() {
      this.$router.push("/loginCheckout");
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    setSaveBox(value) {
      this.saveAddress = value;
    },
    setDefaultBox(value) {
      this.defaultAddress = value;
    },
    setAddress(addressSelected) {
      if (addressSelected == "Add new address") {
        this.name = "";
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.states = "";
        this.zipcode = "";
      } else {
        this.$store.state.user.addressBook.forEach(address => {
          if (address.address1 == addressSelected) {
            this.name = address.name;
            this.address1 = address.address1;
            this.address2 = address.address2;
            this.city = address.city;
            this.states = address.state;
            this.zipcode = address.zipcode;
          }
        });
      }
    },
    guestContinue() {
      if (
        this.email == "" ||
        this.name == "" ||
        this.address1 == "" ||
        this.city == "" ||
        this.states == "" ||
        this.zipcode == ""
      ) {
        this.error = "Please enter information for all required fields";
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      } else {
        this.$store.dispatch("setShippingInfo", {
          email: this.email,
          name: this.name,
          address1: this.address1,
          address2: this.address2,
          city: this.city,
          state: this.states,
          zipcode: this.zipcode
        });
        this.$router.push("/charge");
      }
    },
    async userContinue() {
      if (
        this.name == "" ||
        this.address1 == "" ||
        this.city == "" ||
        this.states == "" ||
        this.zipcode == ""
      ) {
        this.error = "Please enter information for all required fields";
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      } else {
        if (this.saveAddress && this.selectedAddress == "Add new address") {
          try {
            let newAdddess = {
              email: this.$store.state.user.email,
              name: this.name,
              address1: this.address1,
              address2: this.address2,
              city: this.city,
              state: this.states,
              zipcode: this.zipcode,
              default: this.defaultAddress
            };
            if (newAdddess.default) {
              this.$store.dispatch("clearDefaultAddress");
            }
            this.$store.dispatch("addAddress", newAdddess);
            const response = await UserService.updateAddressBook(
              this.$store.state.user.addressBook
            );
            this.$store.dispatch("setShippingInfo", newAdddess);
            this.$router.push("/charge");
          } catch (error) {
            this.error = error.response.data.error;
            this.isErrorShake = true;
            setTimeout(() => {
              this.isErrorShake = false;
            }, 800);
          }
        } else {
          this.$store.dispatch("setShippingInfo", {
            email: this.$store.state.user.email,
            name: this.name,
            address1: this.address1,
            address2: this.address2,
            city: this.city,
            state: this.states,
            zipcode: this.zipcode
          });
          this.$router.push("/charge");
        }
      }
    },
    async register() {
      if (this.email == "" || this.password == "" || this.password2 == "") {
        this.error = "Please enter information for all of the fields";
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      } else {
        if (this.password !== this.password2) {
          this.error = "Passwords do not match";
          this.isErrorShake = true;
          setTimeout(() => {
            this.isErrorShake = false;
          }, 800);
        } else {
          try {
            const response = await AuthenticationService.register({
              email: this.email,
              password: this.password
            });
            this.$store.dispatch("setToken", response.data.token);
            this.$store.dispatch("setUser", response.data.user);
            this.error = "";
            this.message = "You are registered!";
            this.selectedAddress = "Add new address";
          } catch (error) {
            this.error = error.response.data.error;
            this.isErrorShake = true;
            setTimeout(() => {
              this.isErrorShake = false;
            }, 800);
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.errorShake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.75s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
